import { render } from "./TriageStageView.vue?vue&type=template&id=3409639c"
import script from "./TriageStageView.vue?vue&type=script&lang=js"
export * from "./TriageStageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__